export const LOCALES = process.env.VUE_APP_I18N_SUPPORTED_LOCALE.split(',')